import ProjectShopLookSection from '../ProjectShopLookSection';
import { isInteriorShoppingEnabled } from '../../lib/projectToolType';

/**
 * @param {{
 *   project: Record<string, unknown> | null;
 *   projectId: string;
 *   generatedImageUrl: string;
 *   shopOpen?: boolean;
 *   onOpenShop: () => void;
 *   onItemsReady?: (payload: { count: number }) => void;
 * }} props
 */
export default function DesignWorkspaceShopSection({
  project,
  projectId,
  generatedImageUrl,
  shopOpen = false,
  onOpenShop,
  onItemsReady,
}) {
  if (!project || !generatedImageUrl || shopOpen || !isInteriorShoppingEnabled(project)) {
    return null;
  }

  return (
    <ProjectShopLookSection
      projectId={projectId}
      generatedImageUrl={generatedImageUrl}
      onOpenShop={onOpenShop}
      onItemsReady={onItemsReady}
    />
  );
}
